/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { saveAs } from 'file-saver'
import JSZip from 'jszip'
import React, { useState } from 'react'

import { mpfRListsHttp } from '../../../assets/ts/api/mpf-r-lists-http'
import { twoDigits } from '../../../assets/ts/formatting/formatting'
import Alert from '../../../components/alert/alert'
import Buttons from '../../../components/buttons/buttons'
import InputCheckbox from '../../../utils/controls/input-checkbox'
import AccordionFiles from './accordion-files'
import './files.css'

const DetailViewFiles = (props: any) => {
  const [modifyFiles, setModifyFiles] = useState<any>([])

  const [alertMessage, setAlertMessage] = useState('')

  const [checkAllFiles, setCheckAllFiles] = useState(false)
  const [displayAlert, setDisplayAlert] = useState(false)
  const [reverseCheckFiles, setReverseCheckFiles] = useState(false)

  const getSelectedFiles = (files: any, allFiles: any) => {
    setModifyFiles(files)
    props?.setAllFiles(allFiles)
    props?.getSelectedFiles(files, allFiles)
  }
  const checkAll = (e: any) => {
    if (checkAllFiles) {
      setReverseCheckFiles(true)
    } else {
      setReverseCheckFiles(false)
    }
    setCheckAllFiles(e)
  }
  async function downloadAllFiles(downloadAll: boolean) {
    const downloadFilesArray = []
    const inquiryOrDueOutList = props.isInquiry ? 'InquiryList' : 'DueOutList'
    const filesToDownload = downloadAll ? props?.allFiles : modifyFiles
    if (!filesToDownload.length) {
      setAlertMessage('Please select at least one document to download.')
      setDisplayAlert(true)
      return
    } else {
      for (const file of filesToDownload) {
        const list = await mpfRListsHttp().getList(inquiryOrDueOutList)
        await list
          .blobs()
          .getContent(props?.currentInquiry?.eKey, file?.fileName, file?.folderName)
          .then(function (data) {
            downloadFilesArray.push({
              arrayBuffer: data,
              fileName: file?.fileName,
              folderName: file?.folderName.split('/')[1],
              type: fileReturnType(file?.metadata),
            })
          })
      }
      Download(downloadFilesArray, 'AllDownload')
    }
  }
  function Download(data, clickedText) {
    const promises = []
    for (const element of data) {
      const tempURL = window.URL.createObjectURL(
        new Blob([element.arrayBuffer], { type: element.type })
      )
      const tempName = element.fileName
      const catFolder = element.folderName
      if (clickedText === 'AllDownload') {
        promises.push(getBinaryDocsData(tempURL, tempName, catFolder))
      } else {
        promises.push(getBinaryDocsData(tempURL, tempName))
      }
    }
    Promise.all(promises).then(
      function (args) {
        const zip = new JSZip()
        for (const element of args) {
          const name = element[0]
          const data = element[1]
          const fldr = element[2]
          zip.folder(fldr).file(name, data)
        }
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          if (props.isInquiry) {
            saveAs(content, props?.currentInquiry?.InquiryID + '.zip')
          } else {
            saveAs(content, props?.currentInquiry?.DueOutID + '.zip')
          }
        })
      },
      function (err) {
        console.error(err)
      }
    )
  }
  function getBinaryDocsData(thisurl, name, foldername) {
    return new Promise(function (resolve, reject) {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', thisurl, true)
      xhr.responseType = 'arraybuffer'
      xhr.addEventListener('load', function () {
        if (xhr.status === 200) {
          resolve([name, new Blob([xhr.response]), foldername])
        }
      })
      xhr.send()
    })
  }
  const fileReturnType = (productMap) => {
    for (const [key, value] of productMap) {
      if (key === 'type') {
        return value
      }
    }
  }

  return (
    <div className='shadow card w-100 p-relative'>
      {displayAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={alertMessage}
          onClick={() => {
            setAlertMessage('')
            setDisplayAlert(false)
          }}
          yes='OK'
        />
      )}
      <div className='card-header border-bottom1 gap-2 d-flex flex-wrap'>
        <div aria-live='polite' tabIndex={0}>
          <InputCheckbox
            checked={modifyFiles?.length === props?.allFiles?.length && props?.allFiles?.length > 0}
            className='me-1 color-primary'
            formClassName='d-flex align-items-center form-xs'
            inputProps={{
              arialabel: 'Files',
              badge: 'badge bgcolor-primary font-12 border-radius3 px-2 py-1 whitetext',
              badgecount: twoDigits(props?.allFiles?.length),
              className: 'title-color20 poppins-semibold font-14 text-nowrap',
              id: 'files',
              label: 'Files',
              name: 'Files',
              type: 'checkbox',
            }}
            onClick={(e: any) => checkAll(e.target.checked)}
          />
        </div>
        <div className='ms-auto d-flex align-items-center gap-1'>
         {props?.allFiles?.length > 0 && <Buttons
            aria-label='Download'
            className='text-nowrap btn-border btn btn-sm font-0 font-xxl-14 color-primary btn-border-radius3 p-relative ms-auto sourcesansprosemibold '
            icon='icon-download me-xxl-1 font-12'
            label='Download'
            onClick={() => downloadAllFiles(false)}
            type='button'
          />}
         { props?.allFiles?.length > 0 && <Buttons
            aria-label='Download All'
            className='text-nowrap btn-border btn btn-sm font-0 font-xxl-14 color-primary btn-border-radius3 p-relative ms-auto sourcesansprosemibold '
            icon='icon-download me-xxl-1 font-12'
            label='Download All'
            onClick={() => downloadAllFiles(true)}
            type='button'
          />}
        </div>
      </div>

      <div className='card-body '>
        <AccordionFiles
          ItemGUID={props?.ItemGUID}
          checkAll={checkAllFiles}
          currentInquiry={props?.currentInquiry}
          getSelectedFiles={getSelectedFiles}
          hideButton={props?.hideButton}
          isInquiry={props.isInquiry}
          reverseCheck={reverseCheckFiles}
          role={props?.role}
          setCheckAll={checkAll}
        />
      </div>
    </div>
  )
}
export default DetailViewFiles
